import { ROUTE_PERMISSIONS } from "../config/routePermissions";

export const getActiveToolIDs = (toolSettings: Record<number, boolean>): number[] => {
    return Object.keys(toolSettings)
    .filter((toolID) => toolSettings[Number(toolID)])
    .map(Number);
};
// Learning Coach Community Screen Sidebar Menu
export const shouldShowLearningCoachCommunity = (userRoleVal: string, activeToolIDs: number[]): boolean => {
    return userRoleVal === 'LEARNING_COACH' && (activeToolIDs.includes(128) || activeToolIDs.includes(166));
};
// Hang Out in the K12 Zone Screen Sidebar Menu (for LC or Student Role, Tool ID 182 required)
export const shouldShowK12Zone = (userRoleVal: string, activeToolIDs: number[]): boolean => {
    return (userRoleVal === 'LEARNING_COACH' || userRoleVal === 'STUDENT') && activeToolIDs.includes(182);
};

// Function to check route permission
export const isRouteAccessible = (userRole: string, path: string): boolean => {
    const route = ROUTE_PERMISSIONS.find(route => route.path === path);
    // console.log(userRole, path, route, "utility");

    return route ? route.roles.includes(userRole) : true;
};

// Chat URL reusable
export const getChatUrl = (identityId: string): string => {
    const baseChatUrl = import.meta.env.VITE_K12_CHAT_URL;
    if (!baseChatUrl) {
      console.warn("Chat URL base is missing in VITE_K12_CHAT_URL");
      return "";
    }
    // Replace placeholder of VITE_K12_CHAT_URL with correct identityId
    return baseChatUrl.replace("{k12_onboarding_identity_id}", identityId);
}; 
export const openChat = (identityId: string | undefined): void => {
    if (!identityId) {
      console.warn("Identity ID missing, cannot open chat.");
      return;
    }
    const chatUrl = getChatUrl(identityId);
    if (chatUrl && chatUrl !== "#") {
      window.open(chatUrl, "_blank");
    }
  };